/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

const formatAdresse = (base, adresse, naissance = false) => {
    const data = {
        ...base,
        ...adresse,
        ...(!_.isNil(adresse.commune) ? { libelleCommune: adresse.commune } : {}),
        ...(!_.isNil(adresse.codePostal) ? { libelleCodePostal: adresse.codePostal } : {}),
        ...(!_.isNil(adresse.voie) ? { libelleVoie: adresse.voie } : {}), 
        ...(!_.isNil(adresse.pays) ? { libellePays: adresse.pays } : {}),
        ...(!_.isNil(adresse.identifiantDepartement) ? { identifiantDepartement: adresse.identifiantDepartement } : {}),
        ...(!_.isNil(adresse.departement) ? { libelleDepartement: adresse.departement } : {}),
        // Permet d'avoir un reset de voie fonctionnel (EX: dans l'étape 2 de l'assistant)
        ...(_.isNil(adresse.voie) && !_.isNil(base?.voie) ? {typeVoie: '', libelleVoie: ''} : {}),
    };

    if (
        (adresse?.codePostal === '' 
        || adresse?.identifiantCodePostal === ''
        || adresse?.commune === ''
        || adresse?.identifiantCommune === '') && !naissance
        
    ){
        data.libelleCodePostal = '';
        data.identifiantCodePostal = null;
        data.libelleCommune = '';
        data.identifiantCommune = null;
    }

    if(naissance && (adresse?.codeDepartement === ''|| adresse?.departement === '') ){
        data.libelleCodePostal = '';
        data.identifiantCodePostal = null;
        data.libelleCommune = '';
        data.identifiantCommune = null;
     }

    return data;
};

export default formatAdresse;
